module.exports = __webpack_public_path__ + "img/hong.168f1db8.png";